/* global Splide */
"use strict";

($dt => {

	$dt.blocks.testimonials = {

		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {

			const slider = container.querySelector('.splide');
			const options = {
				type: 'loop',
				pauseOnHover: true,
				pauseOnFocus: true,
				gap: '20px',
				pagination: false,
				arrows: false,
				drag: false
			};
			const splide = new Splide(slider, options).mount();
			if (splide.length > 1) {
				splide.options = {
					autoplay: true,
					interval: 7000,
					arrows: true,
					breakpoints: {
						767: {
							padding: '3%'
						},
						4000: {
							padding: '20%'
						}
					}
				};
			}
			//console.log(splide);
			splide.mount();
		}

	};

})(window.d3_wp_themejs);
